import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SearchProvider } from "./context/SearchContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { SearchPage } from "./pages/SearchPage";
import { ShowDetailPage } from "./pages/ShowDetailPage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { NotFoundPage } from "./pages/NotFoundPage";

// Vite injects BASE_URL based on the `base` option in vite.config.ts so the
// router works at any subpath (e.g. GitHub Pages at /ConcertDeals/).
const basename = import.meta.env.BASE_URL.replace(/\/$/, "");

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter basename={basename || undefined}>
        <SearchProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="search" element={<SearchPage />} />
              <Route path="shows/:showId" element={<ShowDetailPage />} />
              <Route path="how-it-works" element={<HowItWorksPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </SearchProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
